import { Box } from '@mui/material';
import type { ReactNode } from 'react';

/**
 * A row that wraps, with separate column and row gaps — ported from Web's
 * `ui/WrapGapRow` (the Project Portfolio panel's details line). Plain flexbox
 * gaps, as Web notes: MUI Stack's gap props do not combine with `flexWrap` for
 * independent column and row values.
 */
export type WrapGapRowProps = {
  /** Horizontal gap, in spacing units. */
  columnGap: 1 | 2 | 3;
  /** Vertical gap between wrapped rows, in spacing units. */
  rowGap: 1 | 2 | 3;
  children: ReactNode;
  automationId?: string;
};

export const WrapGapRow = ({ columnGap, rowGap, children, automationId }: WrapGapRowProps) => (
  <Box
    data-automation-id={automationId}
    sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', columnGap, rowGap }}
  >
    {children}
  </Box>
);
